<template>
  <div class="home1" :class="[archivesData.length === 0 ? 'no-data' : '']">
    <vx-list
      style="height: 100%"
      :api="$api.getArchivesPage"
      :params="archiveParams"
      @load="loadArchives"
      ref="vxlist"
    >
      <div class="schedule" v-if="tabList.length">
        <div class="schedule-bg"></div>
        <div>
          <div class="schedule-banner">
            {{ titleList[active] }}
          </div>
          <div class="schedule-wrap">
            <div class="navs-box">
              <div
                class="navs"
                :class="{ active: active == item.type }"
                v-for="item in tabList"
                :key="item.type"
                @click="active = item.type"
              >
                {{ item.text }}
              </div>
            </div>
            <template v-if="active == 0">
              <homeScheduleComp :courseData="courseData"></homeScheduleComp>
            </template>
            <template v-if="active == 1">
              <homeReserveComp :reserveData="reserveData" @refreshReserve="initReserve">
              </homeReserveComp>
            </template>
          </div>
        </div>
      </div>
      <div class="box dynamic" v-if="dynamicData.length > 0 && showNews">
        <van-notice-bar
          :scrollable="false"
          color="var(--g7)"
          background="var(--white)"
          mode="link"
          class="notice-bar"
          @click="$router.push(`/dynamicNoticeList`)"
        >
          <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
            <van-swipe-item v-for="(item, index) in dynamicData" :key="index" class="van-ellipsis">
              <span class="tag" :class="{ c2: item.operate == 2, c3: item.operate == 3 }">{{
                item.typeName
              }}</span
              >{{ item.title }}
            </van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>
      <div class="box" v-if="list.length">
        <div class="box-title">学习天地</div>
        <div class="box-wrap">
          <div class="box-wrap-item" v-for="item in list" :key="item.text" @click="toLinkUrl(item)">
            <span class="img-wrap">
              <img
                class="img"
                :src="'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/' + item.icon"
              />
              <div class="num" v-if="item.showNum && noReadCount > 0">
                {{ noReadCount > 99 ? 99 : noReadCount }}
              </div>
            </span>
            <div class="txt">{{ item.text }}</div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-title flex-between">
          <span>成长记录</span>
          <div class="filter">
            <span class="filter-option" @click="openFilter1">
              {{ defineStudent.id ? defineStudent.name : '全部学员' }}
              <van-icon
                class="icon"
                class-prefix="vxs-icon"
                name="system_choose"
                size="12"
                color="var(--g5)"
              ></van-icon>
            </span>
            <span class="filter-option" @click="openFilter2">
              {{ selectedType.name }}
              <van-icon
                class="icon"
                class-prefix="vxs-icon"
                name="system_choose"
                size="12"
                color="var(--g5)"
              ></van-icon>
            </span>
          </div>
        </div>
        <div class="wechatRouter" v-if="isOpenGrowth">
          <span>为你的孩子生成了专属成长集，点击查看</span>
          <van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)" />
          <new-vx-wx-open-launch-weapp
            username="gh_31aa8cfb0ae9"
            path="src/pages/index/index"
            appid="wx46ba9c6fa3fa010c"
            :parentState="true"
          ></new-vx-wx-open-launch-weapp>
        </div>
        <div class="archive-item" v-for="item in archivesData" :key="item.id">
          <!-- 阶段测评 -->
          <div
            class="card"
            v-if="item.baseArchivesTypeType == 2"
            @click="$router.push(`/evaluation-detail/${item.id}`)"
          >
            <div class="card-top">
              <div class="header flex-between">
                <div class="top-left flex-between">
                  <div class="photo">{{ item.students[0] && item.students[0].name.slice(-2) }}</div>
                  <div v-if="item.students.length == 1">
                    {{ item.students[0] && item.students[0].name }}
                    <span class="gray">的阶段测评</span>
                  </div>
                  <div v-else>
                    {{ item.students[0] && item.students[0].name }} 等{{
                      item.students.length
                    }}位学员
                    <span class="gray">的阶段测评</span>
                  </div>
                </div>
                <van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)" />
              </div>
              <vx-mult-input-intro :list="item.content.list">
                <template #title>
                  {{ item.stageTest.title }}
                </template>
              </vx-mult-input-intro>
              <div class="teacher">老师：{{ item.operatorName }}</div>
              <div class="type-list-wrapper">
                <div class="type-item" v-for="(type, idx) in item.stageTest.stageTestTypes" :key="idx">
                  <div class="type-title">{{ type.name }}：</div>
                  <div class="tags-wrapper">
                    <div class="tag" v-for="dimension in type.dimensionList" :key="dimension.id">
                      <template v-if="type.scoreType == 1">
                        <span>{{ dimension.name }}：{{ dimension.score }}</span>
                      </template>
                      <template v-else>
                        <span>{{ dimension.name }}：{{ dimension.score }}</span>
                        <van-icon
                          class="icon"
                          class-prefix="vxs-icon"
                          :name="shape[type.scoreIcon]"
                          size="10"
                          color="#FAAB0C"
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-bottom van-hairline--top flex-between">
              <span>{{ item.createTime | formatGoodDate() }}</span>
            </div>
          </div>

          <!-- 成长记录 -->
          <div
            class="card"
            v-if="item.baseArchivesTypeType == 1"
            @click="$router.push(`/growup-record-detail/${item.id}`)"
          >
            <div class="card-top">
              <div class="header flex-between">
                <div class="top-left flex-between">
                  <div class="photo">{{ item.students[0] && item.students[0].name.slice(-2) }}</div>
                  <div>
                    {{ item.students[0] && item.students[0].name }}
                    <span class="gray">的{{ item.baseArchivesTypeName }}</span>
                  </div>
                  <!-- <div v-else>
                    {{ item.students[0] && item.students[0].name }} 等{{
                      item.students.length
                    }}位学员
                    <span class="gray">的{{ item.baseArchivesTypeName }}</span>
                  </div> -->
                </div>
                <van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)" />
              </div>
              <!-- <div class="title">{{ item.title }}</div> -->
              <vx-mult-input-intro :list="item.content.list"></vx-mult-input-intro>
              <div class="teacher">老师：{{ item.operatorName }}</div>              
            </div>
            <div class="card-bottom van-hairline--top flex-between">
              <span>{{ item.createTime | formatGoodDate() }}</span>
              <!-- <div class="flex-center">
                <van-icon
                  class="share-icon"
                  class-prefix="vxs-icon"
                  name="fenxiang"
                  size="var(--fs-lg)"
                  color="var(--g5)"
                />
                分享
              </div> -->
            </div>
          </div>

          <!-- 课堂点评 -->
          <div
            class="card"
            v-if="item.baseArchivesTypeType == 3"
            @click="$router.push(`/commentDetail/${item.courseComment.commentRecordId}`)"
          >
            <div class="card-top">
              <div class="header flex-between">
                <div class="top-left flex-between">
                  <div class="photo">{{ item.students[0] && item.students[0].name.slice(-2) }}</div>
                  <div v-if="item.students.length == 1">
                    {{ item.students[0] && item.students[0].name }}
                    <span class="gray">的{{ item.baseArchivesTypeName }}</span>
                  </div>
                  <div v-else>
                    {{ item.students[0] && item.students[0].name }} 等{{
                      item.students.length
                    }}位学员
                  </div>
                </div>
                <van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)" />
              </div>
              <div class="title">{{ item.title }}</div>
              <vx-mult-input-intro :list="item.courseComment.commentContent.list"></vx-mult-input-intro>
              <div class="teacher" v-if="item.courseComment.classTime">
                {{ item.courseComment.className }}&nbsp;{{
                  item.courseComment.classTime.date | formatDatetime('MM-dd')
                }}({{ item.courseComment.classTime.weekdayName }})&nbsp;{{
                  item.courseComment.classTime.startTime
                }}～{{ item.courseComment.classTime.endTime }}
              </div>
              <!-- <div class="teacher">老师：{{ item.operatorName }}</div> -->
              <div class="teacher">上课老师：{{ item.courseComment.teacherName || '-' }}</div>
              <div class="teacher">
                到课状态：{{ signStatus[item.courseComment.courseStudentStatus] }}
              </div>
              <div class="teacher">
                课堂打分：<span class="dafen">{{ item.courseComment.score }}</span>
              </div>
            </div>
            <div class="card-bottom van-hairline--top flex-between">
              <span>{{ item.createTime | formatGoodDate() }}</span>
              <!-- <div class="flex-center">
                <van-icon
                  class="share-icon"
                  class-prefix="vxs-icon"
                  name="fenxiang"
                  size="var(--fs-lg)"
                  color="var(--g5)"
                />
                分享
              </div> -->
            </div>
          </div>

          <!-- 测评报告 -->
          <div
            class="card"
            v-if="item.baseArchivesTypeType == 4"
            @click="$router.push(`/cepingDetail/${item.evaluation.id}`)"
          >
            <div class="card-top">
              <div class="header flex-between">
                <div class="top-left flex-between">
                  <div class="photo">{{ item.students[0] && item.students[0].name.slice(-2) }}</div>
                  <div>
                    {{ item.students[0] && item.students[0].name }}
                    <span class="gray">的{{ item.baseArchivesTypeName }}</span>
                  </div>
                </div>
                <van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)" />
              </div>
              <div class="title">{{ item.evaluation.title }}</div>
              <div class="teacher">老师：{{ item.operatorName }}</div>     
            </div>
            <div class="card-bottom van-hairline--top flex-between">
              <span>{{ item.createTime | formatGoodDate() }}</span>
            </div>
          </div>
        </div>

        <van-empty
          v-if="archivesData.length === 0"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          image-size="128"
          style="padding: 16px 0"
          description="暂无动态～"
        >
        </van-empty>
      </div>
    </vx-list>

    <van-popup
      get-container="body"
      v-model="showAction1"
      round
      closeable
      position="bottom"
      class="home1-student-type-select-popup"
    >
      <div class="title flex-center">选择学员</div>
      <div class="action-item" @click="stuChange(item)" v-for="item in studentList" :key="item.id">
        <div class="item-left">{{ item.name }}</div>
        <div class="item-right">
          <van-icon
            v-if="defineStudent.id == item.id"
            name="success"
            size="var(--fs-ex1)"
            color="var(--c1)"
          />
        </div>
      </div>
    </van-popup>

    <van-popup
      get-container="body"
      v-model="showAction2"
      round
      position="bottom"
      class="home1-message-type-select-popup"
      @close="closeAction2"
    >
      <div class="title flex-center">
        选择类型
        <van-icon
          name="cross"
          size="22"
          color="var(--g5)"
          class="icon"
          @click="showAction2 = false"
        ></van-icon>
      </div>
      <div
        class="action-item"
        v-for="item in actionsList2"
        :key="item.id"
        @click="selectAction(item)"
      >
        <div class="item-left">{{ item.name }}</div>
        <div class="item-right">
          <van-icon
            v-if="selectedType.id == item.id"
            name="success"
            size="var(--fs-ex1)"
            color="var(--c1)"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import homeScheduleComp from './components/home-schedule-comp.vue';
import homeReserveComp from './components/home-reserve-comp.vue';
import newVxWxOpenLaunchWeapp from "@x3/vue/comp/new-vx-wx-open-launch-weapp.vue";

export default {
  data() {
    return {
      showNews: true,
      signStatus: ['', '出勤', '迟到', '请假', '缺勤'],
      courseData: [],
      reserveData: [],
      dynamicData: [],
      archivesData: [],
      shape: ['xing', 'xin', 'zan', 'hua'],
      active: 0,
      tabList: [],
      titleList: {
        0: '最近课程',
        1: '最近可约课程',
      },
      list: [
        {
          text: '约课',
          path: '/reserveList',
          icon: '010.png',
        },
        {
          text: '课表',
          path: '/classSchedule',
          icon: '005.png',
        },
        {
          text: '上课统计',
          path: '/baseClassStatistics',
          icon: '006.png',
        },
        {
          text: '练习',
          icon: '007.png',
        },
        {
          text: '通知',
          path: '/notice-list',
          icon: '012.png',
          showNum: true,
        },
        {
          text: '请假',
          path: '/time-off-list',
          icon: '013.png',
          showNum: false,
        }
      ],
      noReadCount: '',
      archiveParams: {},

      showAction1: false,
      studentList:[],
      defineStudent:{},

      showAction2: false,
      actionsList2: [],
      selectedType: {
        id: 0,
        name: '全部类型',
        ids: [],
      },
      isOpenGrowth: app.parent.user.isOpenGrowth
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
  },
  filters: {
    defineFormatDate(date) {
      let day = app.tool.date.formatDatetime(date, 'yyyy-MM-dd'),
        today = app.tool.date.formatDatetime(Date.now(), 'yyyy-MM-dd');
      if (day == today) {
        return '今日/' + app.tool.date.getWeek(date);
      } else {
        return app.tool.date.formatDatetime(date, 'MM-dd') + '/' + app.tool.date.getWeek(date);
      }
    },
  },
  created() {
    this.showNews = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'NEW_MSG' && item.openStatus == 1) : true
    const showCourse = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'COURSE_SCHEDULE' && item.openStatus == 1) : true
    if (showCourse) {
      this.tabList.push({
          type: 0,
          text: '我的课表',
        })
    }

    const showReverse = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'COURSE_RESERVE' && item.openStatus == 1) : true;
    if (showReverse) {
       this.tabList.push({
          type: 1,
          text: '我要约课',
        })
        if (!showCourse) {
          this.active = 1;
        }
    }

    this.initCourse();
    this.initDynamic();

    this.getNoticeData();
    this.$onBus('refresh-notice-num', () => {
      this.getNoticeData();
    });
    

    this.$api
      .archivesTypeList({
        deleted: false,
        page: {
          pageNum: 1,
          pageSize: 999,
        },
      })
      .then(res => {
        this.actionsList2 = res.data.map(item => {
          return Object.assign({}, item, {
            ids: [item.id],
          });
        });
        this.actionsList2.unshift({
          id: 0,
          name: '全部类型',
          ids: [],
        });
      });

    this.$api.parentGetStudentList().then(res => {
      this.$toast.clear();
      this.studentList = res.data;
      this.studentList.unshift({
        id:0,
        name: '全部学员'
      })
    });

    if (this.userInfo.companyAppOpenList.indexOf('FACE_IN') > -1) {
      //如果机构未开通脸到则不显示签到入口
      this.list.push({
        text: '签到',
        path: '/face/home/0',
        icon: '009.png',
      });
    }
    // if (this.userInfo.enableLeave) {
    //   //如果机构未放开请假到则不显示请假入口
    //   this.list.push(        {
    //       text: '请假',
    //       path: '/time-off-list',
    //       icon: '013.png',
    //       showNum: false,
    //     });
    // }


    const menuOpenList = this.userInfo.parentMenuOpenList;
    if (menuOpenList){
      this.list = this.list.filter( item=>{
        if (item.text === '约课') {
          if (menuOpenList.some(menu=>menu.menuCode === 'COURSE_RESERVE' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '课表') {
          if (menuOpenList.some(menu=>menu.menuCode === 'COURSE_SCHEDULE' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '上课统计') {
          if (menuOpenList.some(menu=>menu.menuCode === 'COURSE_STATISTICS' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '练习') {
          if (menuOpenList.some(menu=>menu.menuCode === 'VZUOYE' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '通知') {
          if (menuOpenList.some(menu=>menu.menuCode === 'NOTICE' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '签到') {
          if (menuOpenList.some(menu=>menu.menuCode === 'FACEIN' && menu.openStatus ==0 )) {
            return false;
          }
        }
        if (item.text === '请假') {
          if (menuOpenList.some(menu=>menu.menuCode === 'LEAVE' && menu.openStatus ==0 )) {
            return false;
          }
        }
  
        return true;
      })
    }
  },
  methods: {
    getNoticeData() {
      this.$api.getReceiverNoticeData().then(res => {
        this.noReadCount = res.data.noReadCount;
      });
    },
    initCourse() {
      this.showLoading();
      this.$api
        .getCourse({
          page: {
            pageNum: 1,
            pageSize: 3,
          },
        })
        .then(res => {
          this.$toast.clear();
          if (res.code === 200) {
            this.courseData = res.data || [];
          } else {
            this.$toast.fail(res.msg || '服务器出错，请稍后重试');
          }
        });
    },
    initReserve() {
      this.showLoading();
      this.$api.homeReserve().then(res => {
        this.$toast.clear();
        if (res.code === 200) {
          this.reserveData = res.data || [];
        } else {
          this.$toast.fail(res.msg || '服务器出错，请稍后重试');
        }
      });
    },
    initDynamic() {
      this.showLoading();
      this.$api
        .findDynamicInfo({
          page: {
            pageNum: 1,
            pageSize: 3,
          },
        })
        .then(res => {
          this.$toast.clear();
          if (res.code === 200) {
            this.dynamicData = res.data || [];
          } else {
            this.$toast.fail(res.msg || '服务器出错，请稍后重试');
          }
        });
    },

    loadArchives(list) {
      this.archivesData = list;
    },

    toLinkUrl(item) {
      if (!this.userInfo.id) {
        app.parent.login();
        return;
      }
      if (item.text === '练习') {
        this.getStudentList();
      } else if (item.path) {
        this.$router.push(item.path);
      }
    },
    getStudentList() {
      this.showLoading();
      this.$api
        .parentGetStudentList()
        .then(res => {
          this.$toast.clear();
          if (res.code === 200 && res.data) {
            if (res.data.length === 0) {
              this.$toast('暂无练习可看');
            } else if (res.data.length === 1) {
              this.toVHomework(res.data[0]);
            } else {
              app.parent.studentList = res.data.map(item => {
                return {
                  id: item.id,
                  gradeName: item.gradeName,
                  name: item.name,
                  companyId: item.companyId,
                };
              });
              this.$router.push('/vSelectStudent');
            }
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    toVHomework(item) {
      this.showLoading();
      this.$api
        .parentGetWeiZuoYeLogin({
          companyId: item.companyId,
          studentId: item.id,
        })
        .then(res => {
          this.$toast.clear();
          if (res.code === 200 && res.data) {
            window.location.href = res.data;
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    openFilter1(){
      this.showAction1 = true;
    },

    openFilter2() {
      this.showAction2 = true;
    },
    closeAction2() {
      this.$set(this.archiveParams, 'baseArchivesTypeIds', this.selectedType.ids);
    },
    selectAction(item) {
      this.selectedType = item;
      this.showAction2 = false;
      this.closeAction2();
    },
    stuChange(item) {
      this.defineStudent = item;
      if (item.id){
        this.archiveParams.studentIds = [item.id];
      } else {
        this.archiveParams.studentIds = [];
      }
      this.showAction1 = false;
      this.$refs.vxlist.refresh();
    },
    handleLaunchFn(e) {
      console.log('handleLaunchFn',e)
    },
    handleErrorFn(e) {
      console.log('handleErrorFn',e)
    },
  },
  watch: {
    active(nv, ov) {
      if (nv == 0) {
        this.initCourse();
      } else if (nv == 1) {
        this.initReserve();
      }
    },
  },
  components: {
    homeScheduleComp,
    homeReserveComp,
    newVxWxOpenLaunchWeapp
  },
};
</script>

<style lang="scss" scoped>
.home1 {
  background-size: 100% calc(var(--w) * 184);
  background-repeat: no-repeat;
  // padding-bottom: calc(var(--gap) * 12);
  .schedule {
    position: relative;
    .schedule-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/011.png);
      width: 100%;
      height: 0;
      padding-top: 57%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      z-index: -1;
    }
    .schedule-banner {
      z-index: 1;
      display: flex;
      align-items: center;
      font-weight: var(--bold);
      font-size: var(--fs-ex1);
      line-height: var(--lh-ex1);
      color: var(--white);
      padding-left: calc(var(--gap) * 18);
      min-height: calc(var(--w) * 75);
      background: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/004.png) right/contain
        no-repeat;
    }
    .schedule-wrap {
      z-index: 1;
      background-color: var(--white);
      margin: 0 calc(var(--gap) * 16);
      overflow: hidden;
      border-radius: 12px;
      .navs-box {
        font-weight: var(--bold);
        color: var(--g8);
        background: linear-gradient(131deg, rgba(0, 201, 131, 0.1), rgba(159, 230, 145, 0.1));
        .navs {
          position: relative;
          display: inline-block;
          margin: 0 calc(var(--gap) * 26);
          font-size: var(--fs-md);
          line-height: calc(var(--gap) * 42);
          &.active {
            color: #08b66e;
            &::after {
              content: '';
              position: absolute;
              left: calc(var(--gap) * 4);
              right: calc(var(--gap) * 4);
              bottom: 0;
              height: calc(var(--w) * 2);
              border-radius: calc(var(--w) * 2);
              background-color: #08b66e;
            }
          }
        }
      }
    }
  }
  .box {
    padding: 0 calc(var(--gap) * 16);
    &.dynamic {
      margin-top: calc(var(--gap) * 12);
      .notice-bar {
        border-radius: 12px;
        height: 52px !important;
        line-height: 52px !important;
        .notice-swipe {
          height: 52px;
          line-height: 52px;
          .tag {
            display: inline-block;
            margin-right: calc(var(--gap) * 8);
            padding: 0 calc(var(--gap) * 8);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--white);
            border-radius: 8px 0px 8px 0px;
            background-color: var(--c4);
            &.c2 {
              background-color: var(--c2);
            }
            &.c3 {
              background-color: var(--g5);
            }
          }
        }
      }
    }
    .box-title {
      padding: calc(var(--gap) * 24) 0 calc(var(--gap) * 12) 0;
      font-size: var(--fs-ex1);
      line-height: var(--lh-ex1);
      color: var(--g8);
      font-weight: var(--bold);
      .filter {
        font-weight: normal;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        .filter-option {
          margin-left: calc(var(--gap) * 16);
        }
      }
    }
    .wechatRouter {
      position: relative;
      width: 100%;
      height: 45px;
      background: #FFFFFF;
      border-radius: calc(var(--gap) * 8);
      display: flex;
      align-items: center;
      padding: 0 calc(var(--gap) * 16);
      justify-content: space-between;
      box-sizing: border-box;
      margin-bottom: calc(var(--gap) * 12);
      font-size: var(--fs-md);
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #ED6A0C;
    }
    .box-wrap {
      padding: calc(var(--gap) * 8);
      background-color: var(--white);
      border-radius: calc(var(--radius-base) * 3);
      display: flex;
      flex-wrap: wrap;
      .box-wrap-item {
        padding: calc(var(--gap) * 6) 0;
        width: 20%;
        flex-direction: column;
        align-items: center;
        text-align: center;
        .img-wrap {
          display: inline-block;
          position: relative;
          .img {
            width: calc(var(--w) * 40);
            height: calc(var(--w) * 40);
          }
          .num {
            width: calc(var(--gap) * 20);
            height: calc(var(--gap) * 20);
            border-radius: 50%;
            border: 1px solid var(--white);
            position: absolute;
            right: calc(var(--gap) * -6);
            top: calc(var(--gap) * -6);
            background: var(--c1);
            color: var(--white);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
          }
        }
        .txt {
          margin-top: calc(var(--gap) * 8);
          color: var(--g8);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
        }
      }
    }

    .archive-item {
      .card {
        margin-bottom: calc(var(--gap) * 12);
        .card-top {
          background-color: var(--white);
          padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
          border-top-left-radius: var(--radius-sm);
          border-top-right-radius: var(--radius-sm);
        }
        .card-bottom {
          background-color: var(--white);
          padding: 0 calc(var(--gap) * 16);
          border-bottom-left-radius: var(--radius-sm);
          border-bottom-right-radius: var(--radius-sm);
          height: 42px;
          color: var(--g6);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          .share-icon {
            margin-right: calc(var(--gap) * 5);
          }
        }

        .header {
          height: calc(var(--w) * 24);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          margin-bottom: calc(var(--gap) * 12);
          .photo {
            display: inline-block;
            width: calc(var(--w) * 24);
            height: calc(var(--w) * 24);
            line-height: calc(var(--w) * 24);
            border-radius: 50%;
            background-color: var(--c1);
            color: var(--white);
            text-align: center;
            vertical-align: middle;
            margin-right: calc(var(--gap) * 8);
          }

          .gray {
            color: var(--g6);
            margin-left: calc(var(--gap) * 8);
          }
          .operation-icon {
            color: var(--g6);
          }
        }
        .title {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
          margin-bottom: calc(var(--gap) * 8);
        }
        .teacher {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
          margin-bottom: calc(var(--gap) * 8);
          .dafen {
            color: #faab0c;
          }
        }

        .type-list-wrapper {
          .type-item {
            display: flex;
            .type-title {
              font-size: var(--fs-md);
              line-height: var(--lh-md);
              color: var(--g6);
              flex: 0 0 auto;
            }
            .tags-wrapper {
              display: flex;
              flex-wrap: wrap;
              .tag {
                margin-left: calc(var(--gap) * 8);
                margin-bottom: calc(var(--gap) * 10);
                padding: 0 calc(var(--gap) * 8);
                border-radius: 4px;
                font-size: var(--fs-sm);
                height: 18px;
                line-height: 18px;
                color: #faab0c;
                background: rgba(250, 171, 12, 0.2);
                flex: 0 0 auto;
                .icon {
                  margin-left: calc(var(--gap) * 2);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.home1.no-data {
  .van-list__finished-text {
    display: none;
  }
}
.home1-message-type-select-popup {
  flex: 1;
  overflow-y: auto;
  color: var(--g8);
  .title {
    position: relative;
    height: 48px;
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
    .icon {
      position: absolute;
      top: 13px;
      right: 16px;
    }
  }
  .action-item {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: calc(var(--gap) * 10) calc(var(--w) * 16);
    background: var(--white);
    &:active {
      background: var(--g2);
    }
    .item-right {
      width: calc(var(--w) * 18);
      height: calc(var(--gap) * 18);
    }
  }
}

.home1-student-type-select-popup {
  flex: 1;
  overflow-y: auto;
  color: var(--g8);
  .title {
    position: relative;
    height: 48px;
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
    .icon {
      position: absolute;
      top: 13px;
      right: 16px;
    }
  }
  .action-item {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: calc(var(--gap) * 10) calc(var(--w) * 16);
    background: var(--white);
    &:active {
      background: var(--g2);
    }
    .item-right {
      width: calc(var(--w) * 18);
      height: calc(var(--gap) * 18);
    }
  }
}
</style>